(() => {
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:window.Shopify?.currency?.active || 'EUR'}).format(cents / 100);
  let lastPack;
  const main = () => document.querySelector('product-info[id^="MainProduct-"]');
  const expireSaleCopy = () => {
    const deadline = document.querySelector('[data-dh-end]')?.dataset.dhEnd;
    const end = Date.parse(deadline || '');
    if (!Number.isFinite(end) || Date.now() < end) return;
    main()?.querySelectorAll('.kaching-bundles__block-title, .kaching-bundles__bar-most-popular').forEach(node => {
      if (['HALLOWEEN SALE', 'OFERTA DE HALLOWEEN'].includes(node.textContent.trim())) node.hidden = true;
    });
  };
  const syncPackOptions = (root) => {
    const picker = root.querySelector('variant-selects');
    const selected = picker?.querySelector('.dh-pack-grid input:checked');
    const host = selected?.closest('.dh-pack-option')?.querySelector('[data-dh-pack-config]');
    if (!picker || !host) return;
    const controls = [...picker.querySelectorAll('.product-form__input')].filter(node => !node.classList.contains('dh-pack-grid'));
    picker.querySelectorAll('[data-dh-pack-config]').forEach(node => { node.hidden = true; });
    controls.forEach(node => host.appendChild(node));
    host.hidden = controls.length === 0;
  };
  const parseDisplayedMoney = (text) => {
    const digits = (text || '').replace(/[^0-9.,]/g, '');
    const decimal = digits.match(/[.,](\d{2})$/);
    return decimal ? Number(digits.slice(0, -3).replace(/[.,]/g, '') + '.' + decimal[1]) : Number(digits.replace(/[.,]/g, ''));
  };
  const syncHeadingPrice = (root, selectedBundle, variant, priceText) => {
    const row = root.querySelector('[data-dh-heading-price]');
    if (!row) return;
    const compareText = selectedBundle ? selectedBundle.querySelector('.kaching-bundles__bar-full-price')?.textContent?.trim() || '' : variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';
    const price = parseDisplayedMoney(priceText);
    const compare = parseDisplayedMoney(compareText);
    const discounted = price > 0 && compare > price;
    const writeText = (node, value) => { if (node.textContent !== value) node.textContent = value; };
    writeText(row.querySelector('[data-dh-heading-current]'), priceText);
    const compareNode = row.querySelector('[data-dh-heading-compare]');
    const saveNode = row.querySelector('[data-dh-heading-save]');
    writeText(compareNode, discounted ? compareText : '');
    writeText(saveNode, discounted ? row.dataset.savingsLabel + ' ' + Math.round((compare - price) / compare * 100) + '%' : '');
    compareNode.hidden = !discounted;
    saveNode.hidden = !discounted;
  };
  const sync = (variant) => {
    const root = main();
    if (!root) return;
    syncPackOptions(root);
    expireSaleCopy();
    if (!variant) {
      try {variant = JSON.parse(root.querySelector('[data-selected-variant]')?.textContent || 'null');} catch {return;}
    }
    const button = root.querySelector('[name="add"]');
    const sticky = document.querySelector('dh-sticky');
    if (!button || !variant) return;
    const selectedBundle = root.querySelector('.kaching-bundles__bar--selected');
    const priceText = selectedBundle?.querySelector('.kaching-bundles__bar-price')?.textContent?.trim() || root.querySelector('.dh-pack-grid input:checked + label .dh-pack-price')?.textContent || money(variant.price);
    syncHeadingPrice(root, selectedBundle, variant, priceText);
    const previewing = root.dataset.dhPreview === 'true';
    if (button.dataset.dhKaching !== 'true' && (previewing || (variant.available && !button.disabled)) && !button.classList.contains('loading')) button.querySelector('span').textContent = `${button.dataset.dhLabel || window.variantStrings.addToCart} · ${priceText}`;
    if (sticky) {
      sticky.querySelector('[data-dh-sticky-price]').textContent = priceText;
      sticky.querySelector('button').disabled = button.disabled || button.classList.contains('loading') || (button.dataset.dhKaching === 'true' && !selectedBundle);
    }
    const chosen = root.querySelector('.dh-pack-grid input:checked');
    const pack = selectedBundle ? selectedBundle.querySelectorAll('.kaching-bundles__bar-variant').length : Number.parseInt(chosen?.value,10);
    if ([1, 2, 6].includes(pack) && lastPack !== undefined && pack !== lastPack) {
      const privacy = window.Shopify?.customerPrivacy;
      if (privacy?.marketingAllowed?.() === true && typeof window.fbq === 'function') window.fbq('trackCustom','DH_PackSelected',selectedBundle ? {pack} : {pack,variant_id:String(variant.id)});
      if (privacy?.analyticsProcessingAllowed?.() === true && typeof window.clarity === 'function') {window.clarity('set','DH_Pack',String(pack)); window.clarity('event','DH_PackSelected');}
    }
    if ([1, 2, 6].includes(pack)) lastPack = pack;
  };
  let observer;
  let buttonObserver;
  let bundleObserver;
  let stickyCleanup;
  const setup = () => {
    observer?.disconnect();buttonObserver?.disconnect();bundleObserver?.disconnect();stickyCleanup?.();
    const button = main()?.querySelector('[name="add"]');
    const sticky = document.querySelector('dh-sticky');
    if (!button || !sticky) return;
    sticky.querySelector('button').onclick = () => {if (!button.disabled) button.click();};
    let frame;
    let banner;
    const resizeObserver = new ResizeObserver(() => schedulePosition());
    const bannerObserver = new MutationObserver(() => schedulePosition());
    const updatePosition = () => {
      frame = null;
      const currentBanner = document.getElementById('shopify-pc__banner');
      if (currentBanner !== banner) {
        resizeObserver.disconnect();
        bannerObserver.disconnect();
        banner = currentBanner;
        if (banner) {
          resizeObserver.observe(banner);
          bannerObserver.observe(banner, {attributes:true, attributeFilter:['style','class','hidden']});
        }
      }
      const viewportHeight = window.innerHeight;
      const bannerRect = banner?.getBoundingClientRect();
      const offset = bannerRect?.height && getComputedStyle(banner).visibility !== 'hidden' && getComputedStyle(banner).display !== 'none' ? Math.max(0, viewportHeight - bannerRect.top) : 0;
      sticky.style.setProperty('--dh-cookie-offset', `${offset}px`);
      const rect = button.getBoundingClientRect();
      sticky.hidden = rect.bottom > 0 && rect.top < viewportHeight - offset;
    };
    const schedulePosition = () => { if (!frame) frame = requestAnimationFrame(updatePosition); };
    observer = new MutationObserver(schedulePosition);
    observer.observe(document.body, {childList:true, subtree:true});
    window.addEventListener('scroll', schedulePosition, {passive:true});
    window.addEventListener('resize', schedulePosition);
    updatePosition();
    stickyCleanup = () => {
      cancelAnimationFrame(frame);
      resizeObserver.disconnect();
      bannerObserver.disconnect();
      window.removeEventListener('scroll', schedulePosition);
      window.removeEventListener('resize', schedulePosition);
    };
    buttonObserver = new MutationObserver(() => sync());
    buttonObserver.observe(button,{attributes:true,attributeFilter:['disabled','class']});
    bundleObserver = new MutationObserver(() => sync());
    bundleObserver.observe(main(),{childList:true,subtree:true,attributes:true,attributeFilter:['class']});
    sync();
  };
  const countdowns = () => {
    document.querySelectorAll('[data-dh-end]').forEach(node => {
      if (node.dataset.initialized) return;
      node.dataset.initialized = 'true';
      const end = Date.parse(node.dataset.dhEnd);
      if (!Number.isFinite(end) || !/(Z|[+-]\d{2}:\d{2})$/.test(node.dataset.dhEnd)) return;
      let timer;
      const tick = () => {
        const seconds = Math.floor((end - Date.now()) / 1000);
        if (seconds <= 0 || !node.isConnected) {
          node.hidden=true;clearInterval(timer);
          if (seconds <= 0) {
            expireSaleCopy();
            const offer = node.parentElement.querySelector('[data-dh-offer-text]');
            if (offer) offer.textContent = offer.dataset.dhExpiredText || '';
          }
          return;
        }
        const showDays=seconds>86400;
        const days=Math.floor(seconds/86400),hours=Math.floor((showDays?seconds%86400:seconds)/3600),minutes=Math.floor(seconds%3600/60);
        node.textContent=`${node.dataset.label} ${showDays?days+' d ':''}${String(hours).padStart(2,'0')} h ${String(minutes).padStart(2,'0')} min`;
        node.hidden=false;
      };
      tick(); if (end>Date.now()) timer=setInterval(tick,1000);
    });
  };
  if (typeof subscribe==='function') subscribe(PUB_SUB_EVENTS.variantChange,({data})=>{if (data.sectionId===main()?.dataset.section) sync(data.variant);});
  document.addEventListener('shopify:section:load',()=>{setup();countdowns();});
  document.addEventListener('product-info:loaded',setup);
  setup();countdowns();
})();

document.addEventListener('click',event=>{
  const link=event.target.closest('.dh-faq-cta a[href="#dh-bundle-selector"], .dh-for-him a[href="#dh-bundle-selector"]');
  if(!link)return;
  const target=document.querySelector('.kaching-bundles__block')||document.querySelector('.dh-bundle-anchor');
  if(!target)return;
  event.preventDefault();
  const old=document.getElementById('dh-bundle-selector');
  if(old&&old!==target)old.id='dh-bundle-fallback';
  target.id='dh-bundle-selector';
  target.setAttribute('tabindex','-1');
  target.scrollIntoView({behavior:'auto',block:'start'});
  target.focus({preventScroll:true});
  const url=new URL(window.location.href);url.hash='dh-bundle-selector';
  window.history.replaceState(window.history.state,'',url);
});
